import { createSlice } from '@reduxjs/toolkit';
const initialState = () => {
    return {
        errors: [],
        dimensions:[],
        companyDimensions:[],
        vaptDimensions: [],
        availableDimensions:[],
        severities:[],
        threatActors: [],
        mitremappings:[],
    };
  };

const vaptDataSlice = createSlice({
  name: 'vaptData',
  initialState:initialState(),
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setDimensions(state, action) {
      state.dimensions = action.payload;
    }, 
    setCompanyDimensions(state, action) {
      state.companyDimensions = action.payload;
    },    
    setVAPTDimensions(state, action){
      state.vaptDimensions = action.payload;
    },
    setAvailableDimensions(state, action){
      state.availableDimensions = action.payload;
    },
    setSeverities(state, action){
      state.severities = action.payload;
    },
    setThreatActors(state, action){
      state.threatActors = action.payload;
    },
    setMitreMappings(state, action) {
      state.mitremappings = action.payload;
    },
  },
});

export const {
  setErrors,
  setDimensions,
  setCompanyDimensions,
  setVAPTDimensions,
  setAvailableDimensions,
  setSeverities,
  setThreatActors,
  setMitreMappings,
} = vaptDataSlice.actions;

export const vaptData = vaptDataSlice.reducer;